var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsologoPaypuntaColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195.08,
    height: 49.754,
    viewBox: "0 0 195.08 49.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M10.914,49.224H47.455v-26.4C47.455,10.219,36.832,0,23.728,0S0,10.219,0,22.824v15.9A10.711,10.711,0,0,0,10.914,49.224Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4",
    "data-name": "Rect\\xE1ngulo 4",
    width: 66,
    height: 50,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M11.039,49.224H48v-26.4C48,10.219,37.255,0,24,0S0,10.219,0,22.824v15.9A10.778,10.778,0,0,0,11.039,49.224Z",
    fill: "#ebebeb",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6",
    "data-name": "Rect\\xE1ngulo 6",
    width: 66,
    height: 50,
    transform: "translate(0 0)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M20.727,79.01V69.346a10.159,10.159,0,0,0-10.317-9.92h-.027A10.218,10.218,0,0,0,0,69.346v1.175c.958,5.04,5.444,8.489,10.859,8.489Z",
    transform: "translate(0 -59.426)",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.4,
    x2: 0.008,
    y2: 0.4,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abce9e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72a065",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.4,
    x2: 0.008,
    y2: 0.4,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abce9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72a065"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M54.463,25.021c-7.532,0-13.637,5.82-13.637,13V62.072H68.1V38.02C68.1,30.841,61.994,25.021,54.463,25.021Z",
    transform: "translate(-40.826 -25.021)",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.314,
    y1: 0.747,
    x2: 0.322,
    y2: 0.747,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89462",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee5b33",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.314,
    y1: 0.747,
    x2: 0.322,
    y2: 0.747,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee5b33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M41.587,73.877V55.921A7.168,7.168,0,0,0,34.224,49a7.168,7.168,0,0,0-7.364,6.921V73.877Z",
    transform: "translate(-26.86 -49)",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.207,
    y1: 0.505,
    x2: 0.214,
    y2: 0.505,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffde98",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffba5f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.207,
    y1: 0.505,
    x2: 0.214,
    y2: 0.505,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffde98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffba5f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M26.86,61.78V79.5h6.545V69.835a10.007,10.007,0,0,0-6.449-9.4A7.165,7.165,0,0,0,26.86,61.78Z",
    transform: "translate(-26.86 -60.431)",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M84.5,79.01V59.426H84.18a9.951,9.951,0,0,0-10.048,9.853l.026.023V79.01Z",
    transform: "translate(-74.132 -59.426)",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M94.545,59.426V79.01h7.62c5.679,0,10.38-4.34,10.38-9.769v.008c0-5.429-4.7-9.822-10.38-9.822Z",
    transform: "translate(-94.545 -59.426)",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M94.545,59.426V79.01h3.984l3.825-.018a9.994,9.994,0,0,0,10.191-9.76v.008a10.039,10.039,0,0,0-10.191-9.813Z",
    transform: "translate(-94.545 -59.426)",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.727,
    y1: 0.4,
    x2: 0.735,
    y2: 0.4,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfa9dc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b70b7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.727,
    y1: 0.4,
    x2: 0.735,
    y2: 0.4,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfa9dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b70b7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "isologo-paypunta-color",
    transform: "translate(-139 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PayPunta",
    transform: "translate(139 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3",
    "data-name": "Rect\\xE1ngulo 3",
    width: 52.531,
    height: 54.301,
    transform: "translate(-2.538 -2.538)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8",
    "data-name": "Grupo 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_5",
    "data-name": "Rect\\xE1ngulo 5",
    width: 53.077,
    height: 54.301,
    transform: "translate(-2.538 -2.538)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12",
    transform: "translate(0 30.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9",
    transform: "translate(0 -30.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7",
    "data-name": "Rect\\xE1ngulo 7",
    width: 66,
    height: 50,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10",
    transform: "translate(0 -30.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_8",
    "data-name": "Rect\\xE1ngulo 8",
    width: 66,
    height: 50,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    transform: "translate(20.727 12.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(-20.727 -12.703)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9",
    "data-name": "Rect\\xE1ngulo 9",
    width: 66,
    height: 50,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14",
    transform: "translate(-20.727 -12.703)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10",
    "data-name": "Rect\\xE1ngulo 10",
    width: 66,
    height: 50,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20",
    transform: "translate(13.637 24.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17",
    transform: "translate(-13.637 -24.877)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_11",
    "data-name": "Rect\\xE1ngulo 11",
    width: 66,
    height: 50,
    transform: "translate(0)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18",
    transform: "translate(-13.637 -24.877)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_12",
    "data-name": "Rect\\xE1ngulo 12",
    width: 66,
    height: 50,
    transform: "translate(0)",
    fill: "url(#linear-gradient-6)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24",
    transform: "translate(13.637 30.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22",
    "data-name": "Grupo 22",
    transform: "translate(-13.637 -30.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_13",
    "data-name": "Rect\\xE1ngulo 13",
    width: 11.623,
    height: 24.15,
    transform: "translate(11.098 28.142)",
    fill: "#7f873c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(37.636 30.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26",
    transform: "translate(-37.636 -30.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 15.44,
    height: 24.661,
    transform: "translate(35.098 27.632)",
    fill: "#943a35"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32",
    transform: "translate(48 30.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(-48 -30.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17",
    "data-name": "Rect\\xE1ngulo 17",
    width: 23.077,
    height: 24.661,
    transform: "translate(45.461 27.632)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36",
    transform: "translate(48 30.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33",
    transform: "translate(-48 -30.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_19",
    "data-name": "Rect\\xE1ngulo 19",
    width: 66,
    height: 50,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(-48 -30.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_20",
    "data-name": "Rect\\xE1ngulo 20",
    width: 66,
    height: 50,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2857",
    "data-name": "Trazado 2857",
    d: "M8.424-5.148H5.512V0H1.924V-17.68h6.5q6.292,0,6.292,6.136a6.548,6.548,0,0,1-1.6,4.745A6.241,6.241,0,0,1,8.424-5.148ZM5.512-8.216H8.4q2.678,0,2.678-3.328a3.456,3.456,0,0,0-.65-2.353A2.612,2.612,0,0,0,8.4-14.612H5.512Zm21.242-.728v5.408a2.072,2.072,0,0,0,.208.871.967.967,0,0,0,.65.351l-.1,2.626A9.848,9.848,0,0,1,25.389.13,4.767,4.767,0,0,1,23.79-.6a8.654,8.654,0,0,1-3.822.91q-4.03,0-4.03-4.264A3.522,3.522,0,0,1,17.056-6.9,6.268,6.268,0,0,1,20.488-7.93l2.782-.208v-.806a1.374,1.374,0,0,0-.364-1.1,1.84,1.84,0,0,0-1.17-.3l-4.888.208-.1-2.418a20.237,20.237,0,0,1,5.291-.754,5.174,5.174,0,0,1,3.614,1.04A4.388,4.388,0,0,1,26.754-8.944ZM20.9-5.512a1.411,1.411,0,0,0-1.456,1.56q0,1.43,1.274,1.43a8.421,8.421,0,0,0,2.158-.312l.39-.1V-5.72ZM28.7-13h3.432L34.5-2.964h.6L37.466-13H40.9L36.322,5.46H32.916L34.346,0H31.9ZM42.9,5.46V-13h3.458v.7a5.976,5.976,0,0,1,2.964-1.014A4.644,4.644,0,0,1,53.2-11.739q1.248,1.573,1.248,5.343T53.066-1.157Q51.688.312,48.542.312A11.876,11.876,0,0,1,46.7.156L46.384.1V5.46Zm5.746-15.652a5.284,5.284,0,0,0-1.95.39l-.312.13V-2.86a15,15,0,0,0,1.9.156,2.254,2.254,0,0,0,2.067-.884A5.954,5.954,0,0,0,50.908-6.6Q50.908-10.192,48.646-10.192ZM64.714-13H68.2V0H64.74V-.728A6.947,6.947,0,0,1,61.49.312q-2.7,0-3.64-1.495a9.9,9.9,0,0,1-.936-5.005V-13H60.4v6.864A7.383,7.383,0,0,0,60.71-3.51q.312.7,1.508.7a6.339,6.339,0,0,0,2.158-.364l.338-.1ZM74.906,0H71.422V-13H74.88v.728a6.511,6.511,0,0,1,3.25-1.04q2.6,0,3.588,1.534a8.914,8.914,0,0,1,.988,4.732V0H79.222V-6.942a5.847,5.847,0,0,0-.39-2.457,1.566,1.566,0,0,0-1.56-.793,5.9,5.9,0,0,0-2.054.364l-.312.1ZM93-10.036H89.8v5.33a10.649,10.649,0,0,0,.039,1.1.9.9,0,0,0,.286.559,1.083,1.083,0,0,0,.767.234l1.976-.052.156,2.782a13.237,13.237,0,0,1-2.652.39q-2.34,0-3.2-1.053T86.32-4.628v-5.408H84.786V-13H86.32v-3.614H89.8V-13H93Zm12.22,1.092v5.408a2.072,2.072,0,0,0,.208.871.967.967,0,0,0,.65.351l-.1,2.626A9.848,9.848,0,0,1,103.857.13a4.767,4.767,0,0,1-1.6-.728,8.654,8.654,0,0,1-3.822.91q-4.03,0-4.03-4.264A3.522,3.522,0,0,1,95.524-6.9,6.268,6.268,0,0,1,98.956-7.93l2.782-.208v-.806a1.374,1.374,0,0,0-.364-1.1,1.84,1.84,0,0,0-1.17-.3l-4.888.208-.1-2.418a20.237,20.237,0,0,1,5.291-.754,5.174,5.174,0,0,1,3.614,1.04A4.388,4.388,0,0,1,105.222-8.944Zm-5.85,3.432a1.411,1.411,0,0,0-1.456,1.56q0,1.43,1.274,1.43a8.421,8.421,0,0,0,2.158-.312l.39-.1V-5.72Z",
    transform: "translate(228 64)",
    fill: "#ff8b22"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsologoPaypuntaColor);
export default __webpack_public_path__ + "static/media/isologo-paypunta-color.e39641dd06ff458a4359d4a85f0247e4.svg";
export { ForwardRef as ReactComponent };